import React from 'react';
import { FixedSizeList } from 'react-window';
import useHeightByAmountOfItems from './utils/useHeightByAmountOfItems.js';

var MenuItem = function MenuItem(_ref) {
  var data = _ref.data,
      index = _ref.index,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    style: style
  }, data[index]);
}; // eslint-disable-next-line no-unused-vars

function VirtualMenuList(_ref2) {
  var items = _ref2.items,
      _ref2$itemHeight = _ref2.itemHeight,
      itemHeight = _ref2$itemHeight === void 0 ? 32 : _ref2$itemHeight,
      _ref2$amountItemsInWi = _ref2.amountItemsInWindow,
      amountItemsInWindow = _ref2$amountItemsInWi === void 0 ? 5 : _ref2$amountItemsInWi,
      width = _ref2.width,
      height = _ref2.height;
  var computedListHeight = useHeightByAmountOfItems({
    amountItems: amountItemsInWindow,
    itemHeight: itemHeight,
    items: items
  });
  return /*#__PURE__*/React.createElement(FixedSizeList, {
    height: height || computedListHeight,
    itemCount: items.length,
    itemData: items,
    itemSize: itemHeight,
    width: width
  }, MenuItem);
}

export default VirtualMenuList;
//# sourceMappingURL=VirtualMenuList.js.map
